import React from "react";
import "../../../assets/css/general/pagination/Pagination.css";

/* ══════════════════════════════════════════
   Reusable Pagination Component
   Usage:
   <Pagination
     currentPage={currentPage}
     totalItems={filtered.length}
     itemsPerPage={10}
     onPageChange={setCurrentPage}
   />
   Data slicing (paginatedData) hamesha parent page mein hoga,
   ye component sirf UI + page-change control deta hai.
══════════════════════════════════════════ */
const Pagination = ({ currentPage, totalItems, itemsPerPage, onPageChange }) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  if (totalPages <= 1) return null;

  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;

    if (totalPages <= maxVisible + 2) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
      return pages;
    }

    pages.push(1);

    let start = Math.max(2, currentPage - 1);
    let end = Math.min(totalPages - 1, currentPage + 1);

    if (currentPage <= 3) end = 4;
    if (currentPage >= totalPages - 2) start = totalPages - 3;

    if (start > 2) pages.push("dots-start");
    for (let i = start; i <= end; i++) pages.push(i);
    if (end < totalPages - 1) pages.push("dots-end");

    pages.push(totalPages);
    return pages;
  };

  const handlePrev = () => {
    if (currentPage > 1) onPageChange(currentPage - 1);
  };

  const handleNext = () => {
    if (currentPage < totalPages) onPageChange(currentPage + 1);
  };

  const startItem = totalItems === 0 ? 0 : (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);

  return (
    <div className="gcAdminPagination">
      <span className="gcAdminPagination-info">
        Showing {startItem}-{endItem} of {totalItems}
      </span>

      <div className="gcAdminPagination-controls">
        <button
          className="gcAdminPagination-btn gcAdminPagination-btn--nav"
          onClick={handlePrev}
          disabled={currentPage === 1}
          aria-label="Previous page"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
            <path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>

        {getPageNumbers().map((page) =>
          typeof page === "string" ? (
            <span key={page} className="gcAdminPagination-dots">
              …
            </span>
          ) : (
            <button
              key={page}
              className={`gcAdminPagination-btn ${page === currentPage ? "gcAdminPagination-btn--active" : ""}`}
              onClick={() => onPageChange(page)}
            >
              {page}
            </button>
          )
        )}

        <button
          className="gcAdminPagination-btn gcAdminPagination-btn--nav"
          onClick={handleNext}
          disabled={currentPage === totalPages}
          aria-label="Next page"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
            <path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default Pagination;